// import React,{Component} from 'react'
// export default class SearchJumper extends Component{
//   render(){
//     return(
//       <div>
//         hello
//       </div>
//     )
//   }
// }


import React, { Component, Fragment } from 'react';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { components } from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import Select from 'react-select';
// import loadsStore from '../../../stores/loads-store';
import Fuse from "fuse.js";
// import ReactDOM from 'react-dom';
// import { DragSource } from 'react-dnd'
// import { connect } from 'react-redux'
// import LoadUpdateModal from './loadModal'
import jumpersStore from '../../../stores/jumpers-store';
import accountStore from '../../../stores/account-store';
import { ClipLoader } from 'react-spinners';
// import { Table } from 'reactstrap';
import RefundConfirMation from '../modals/refundConfirmation'
import ViewDetail from '../modals/jumperDetail';
import TransferCredit from '../modals/transferCredit';
import ChargeJumper from '../modals/chargeJumper';
import AddItem from '../modals/addItem';

import {
	Modal, ModalHeader, ModalBody, Col, Row, Label
} from 'reactstrap';

const Types = {
	ITEM: 'FunJump'
};


const customStyles = {
	control: base => ({
		...base,
		minHeight: 30
	}),
	menu: (provided, state) => ({
		...provided,
		borderBottom: "1px dotted pink",
		color: "black",
		padding: 20,
		height: 530
	}),
	menuList: (provided, state) => ({
		...provided,
		borderBottom: "1px dotted pink",
		padding: 20,
		minHeight: 500
	})
};

class SearchJumper extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isModalOpen: false,
			isLoading: true,
			dailyActivity: {},
			cardsOnFile: [],
			jumperId: '',
			transactionAmount: this.props.transactionAmount,
			transactionId: this.props.transactionId,
			isTandemStudent: false
		};

		this.jumperEvents = [
			{ name: jumpersStore.getEventPrefix('dailyActivity'), func: this.handleDailyActivity },
			{ name: jumpersStore.getEventPrefix('transfer'), func: this.handleTransfer },
		];

		this.accountsEvents = [
			{ name: accountStore.getEventPrefix('itemsAdded'), func: this.handleItemsAdded },
			{ name: accountStore.getEventPrefix('chargeAdded'), func: this.handleChargeAdded }
		];

		this.gearIds = [];
		this.valRef = null;
		this.inputValue = '';
		this.fuse=undefined;
		this.isConfirm = true;
	}

	componentDidMount = () => {
		if (this.valRef !== null)
			this.valRef.focus();
		this.setFuse(this.props.options);
	}

	setFuse = (jumperOptions) => {
		var options = {
			shouldSort: true,
			tokenize: true,
			threshold: 0.1,
			location: 0,
			distance: 100,
			maxPatternLength: 32,
			minMatchCharLength: 2,
			keys: [
				"value.manifestNumber",
				"value.firstname",
				"value.lastname"
			]
		};

		this.fuse = new Fuse(jumperOptions, options);
	}

	componentDidUpdate = () => {
		if (this.valRef !== null)
			this.valRef.focus();
		this.setFuse(this.props.options);
	}

	componentWillMount = () => {
		this.jumperEvents.forEach((evnt) => jumpersStore.on(evnt.name, evnt.func));
		this.accountsEvents.forEach((evnt) => accountStore.on(evnt.name, evnt.func));
	}

	componentWillUnmount = () => {
		this.jumperEvents.forEach((evnt) => jumpersStore.removeListener(evnt.name, evnt.func));
		this.accountsEvents.forEach((evnt) => accountStore.removeListener(evnt.name, evnt.func));
	}

	handleTransfer = () => { }

	handleItemsAdded = () => { }

	handleChargeAdded = () => { }

	handleDailyActivity = (data) => {
		//console.log('in handleDailyActivity');
		//console.log(dailyActivity);
		console.log("dailyActivity atfer chgne value", data.dailyActivity);
		var cardsOnFile = [];
		// if (!data.isTandemStudent) {
		// 	cardsOnFile = jumpersStore.getJumperById(data.jumperId).cardsOnFile;
		// }
		console.log("start saveing value");
		this.setState({
			dailyActivity: data.dailyActivity,
			jumperId: data.jumperId,
			isTandemStudent: data.isTandemStudent,
			isLoading: false,
			cardsOnFile: cardsOnFile
		}, () => console.log("dailyActivitydailyActivity from under state", this.state.dailyActivity));
	}

	handleChargeAdded = (data) => {
		//console.log('in handle charge added');
		this.setState({
			dailyActivity: data.dailyActivity
		})
	}

	handleItemsAdded = (data) => {
		//same as handle DailyActivity for now
		//console.log('in handleItemsAdded');
		//console.log(data.dailyActivity);

		this.setState({
			dailyActivity: data.dailyActivity
		});
	}

	handleTransfer = (data) => {
		//console.log('in handleDailyActivity');
		//console.log(dailyActivity);

		//console.log(data.dailyActivity);
		this.setState({
			dailyActivity: data.fromActivity,
			jumperId: data.fromId
		});
	}

	handleTandemSelect = (val) => {
		//console.log('in handleSelectTandem');
		//console.log(val.value);
		if (val.value !== undefined) {
			//this.onJumperChanged(val.value);
			//console.log("tandemid", val)
			jumpersStore.getDailyTandemActivity(val.value);
		}
		this.setState({ isModalOpen: true, isLoading: true });
	}

	updateGear = (value) => {
		var id = value.target.name.substr(4);
		if (value.target.checked) {
			this.gearIds.push(id);
		}
		else {
			this.gearIds = this.gearIds.filter(gearId => gearId !== id);
		}
	}

	Option = (props) => {
		var gearModel = ".gear" + props.data.value._id;
		var name = "gear" + props.data.value._id
		return (
			<div className="row">
				<div className="col-8">
					<components.Option {...props} />
				</div>
				<div className="col-4" style={{ paddingTop: '6px' }}>
					gear <Control.checkbox model={gearModel} name={name} onChange={value => { this.updateGear(value) }} />
				</div>
			</div>
		);
	}

	SingleValueLabel = ({ children, ...props }) => {
		return (
			<components.SingleValue {...props}><div className="row"> <div className="col-12">{children}</div>{this.gearIds.indexOf(props.data.value._id) > -1 ? <div className="col-12">-G</div> : null}</div></components.SingleValue>
		);
	}

	handleSelect = (selectedOption) => {

		console.log("selectedOption", selectedOption)

		jumpersStore.getDailyActivity(selectedOption.value._id)

		this.setState({ isModalOpen: true, isLoading: true });
	}

	closeModal = () => {
		this.setState({ isModalOpen: false });
	}


	filterJumpers = (inputValue, jumperOptions) => {
		if (inputValue) {
			var filteredOptions = this.fuse.search(inputValue.toLowerCase());
			if (filteredOptions.length > 30) return filteredOptions = filteredOptions.slice(0, 30);
			else return filteredOptions;
		}
		return jumperOptions;
	};

	promiseOptions = (inputValue, jumperOptions) => {
		return new Promise(resolve => {
			resolve(this.filterJumpers(this.inputValue, jumperOptions));
		});
	}

	handleInputChange = (newValue) => {
		this.inputValue = newValue;
		//this.valRef.focus();
	};

	onBlur = (mode, isCompleted) => {
		//if(this.state.editMode && !this.props.isCompleted)
		//{
		alert('bluring');
	}

	checkForNegatives = (price) => {
		//console.log('check for negatives: ' + price);
		if (price != undefined) {
			let priceCell = (price < 0) ?
				{
					value: `($${Math.abs(price).toFixed(2)})`
				} :
				{
					value: `$${price.toFixed(2)}`
				}

			if (price < 0) {
				return <span style={{ color: 'red' }}> {priceCell.value}</span>;
			}
			return priceCell.value;
		}
		else {
			return '$0.00';
		}
	}
	renderMemo = (memo) => {
		return <tr><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"memo: " + memo}</td></tr>
	}

	renderSummary() {
		console.log("this.state.dailyActivity in rendersumery", this.state.dailyActivity)
		var counterSalesPrice = 0;
		var countersales = null;
		if (this.state.dailyActivity.countersales) {
			countersales = this.state.dailyActivity.countersales.map(sale => {
				counterSalesPrice = counterSalesPrice + sale.price;
				// return(<p style={{textAlign:'left',paddingLeft:'8px'}}><div style={{width:'134px !important',display:'inline-block'}}>{sale.item.toUpperCase()}</div> : {sale.count} : ${sale.price}</p>)
				if (sale.item != undefined) {
					return (
						<React.Fragment>
							<tr><td>{sale.item !== undefined ? sale.item.toUpperCase() : 'Item'}</td> <td> {sale.count}</td> <td> {this.checkForNegatives(sale.price)}</td>{sale.item !== "transfer" ? <td><button className="btn lightBlueButton" onClick={() => accountStore.DeleteItem(this.state.jumperId, sale._id)}><i className="fa fa-times" /> </button></td> : null}</tr>
							{sale.description !== undefined ? <tr><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{sale.description}</td></tr> : ''}
							{sale.memo !== undefined && sale.memo !== "" ? this.renderMemo(sale.memo) : null}
						</React.Fragment>
					)
				}
			});
		}

		var charges = null;
		if (this.state.dailyActivity.charges) {
			charges = this.state.dailyActivity.charges.map(charge => {

				if (charge.amount !== undefined) {
					return (
						<React.Fragment>
							<tr><td>{charge.amount !== undefined && !charge.isRefund ? 'CHARGE' : 'REFUND'}</td>
								<td></td>
								<td>{this.checkForNegatives(charge.amount)}</td>
								{
									!charge.isRefund ?
										<td>
											{/* <button className="btn lightBlueButton" onClick ={() => this.refundJumper(charge)}>
										<i className="fa fa-undo" />
									</button> */}
											<RefundConfirMation jumperId={this.state.jumperId} chargeValue={charge} />
										</td>
										: null
								}</tr>
							<tr><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{charge.transactionType.toUpperCase()}</td></tr>
							{charge.memo ? this.renderMemo(charge.memo) : null}
						</React.Fragment>
					)
				}
			});
		}
		return (
			<div className="">
				<h4 style={{ marginLeft: '9px' }}>{this.state.dailyActivity.name}</h4>
				{/* <table className="StaffSummary StaffSummary" style={{ marginLeft: '6px', width: '97%', height: '200px', display: 'inline-block', overflow: 'auto' }}> */}
				<table className="StaffSummary accountSummary">
					<tbody>
						{this.state.dailyActivity.tandemStudentJumps > 0 ?
							<tr>
								<td>TANDEMS</td>
								<td>{this.state.dailyActivity.tandemStudentJumps}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.tandemValue)}</td>
							</tr>
							: null}
						{this.state.dailyActivity.tandemStudentJumps > 0 && this.state.dailyActivity.videos !== 0 ?
							<tr>
								<td>TANDEM VIDEOS</td>
								<td>{this.state.dailyActivity.videos}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.videosValue)}</td>
							</tr>
							: null}
						{this.state.dailyActivity.aff1 !== undefined && this.state.dailyActivity.aff1.count !== 0 ?
							<tr>
								<td>AFF 1 JUMPS</td>
								<td>{this.state.dailyActivity.aff1.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.aff1.value)}</td>
							</tr>
							: null}
						{this.state.dailyActivity.aff2_3 !== undefined && this.state.dailyActivity.aff2_3.count !== 0 ?
							<tr>
								<td>AFF 2-3 JUMPS</td>
								<td>{this.state.dailyActivity.aff2_3.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.aff2_3.value)}</td>
							</tr>
							: null}
						{this.state.dailyActivity.aff4_7 !== undefined && this.state.dailyActivity.aff4_7.count !== 0 ?
							<tr>
								<td>AFF 4-7 JUMPS</td>
								<td>{this.state.dailyActivity.aff4_7.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.aff4_7.value)}</td>
							</tr>
							: null}
						{this.state.dailyActivity.funJumps !== undefined && this.state.dailyActivity.funJumps.count !== 0 ?
							<tr>
								<td>FUN JUMPS</td>
								<td>{this.state.dailyActivity.funJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.funJumps.value)}</td>
							</tr>
							: null}
						{this.state.dailyActivity.aff1Jumps !== undefined && this.state.dailyActivity.aff1Jumps.count !== 0 ?
							<tr>
								<td>AFF 1 INSTRUCTOR JUMPS</td>
								<td>{this.state.dailyActivity.aff1Jumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.aff1Jumps.value)}</td>
							</tr>
							: null}
						{this.state.dailyActivity.aff2_3Jumps !== undefined && this.state.dailyActivity.aff2_3Jumps.count !== 0 ?
							<tr>
								<td>AFF 2-3 INSTRUCTOR JUMPS</td>
								<td>{this.state.dailyActivity.aff2_3Jumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.aff2_3Jumps.value)}</td>
							</tr>
							: null}
						{this.state.dailyActivity.aff4_7Jumps !== undefined && this.state.dailyActivity.aff4_7Jumps.count !== 0 ?
							<tr>
								<td>AFF 4-7 INSTRUCTOR JUMPS</td>
								<td>{this.state.dailyActivity.aff4_7Jumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.aff4_7Jumps.value)}</td>
							</tr>
							: null}

						{this.state.dailyActivity.tandemJumps !== undefined && this.state.dailyActivity.tandemJumps.count !== 0 ?
							<tr>
								<td>TANDEM JUMPS</td>
								<td>{this.state.dailyActivity.tandemJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.tandemJumps.value)}</td>
							</tr>
							: null}

						{this.state.dailyActivity.tandemUltraJumps !== undefined && this.state.dailyActivity.tandemUltraJumps.count !== 0 ?
							<tr>
								<td>TANDEM ULTRAS</td>
								<td>{this.state.dailyActivity.tandemUltraJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.tandemUltraJumps.value)}</td>
							</tr>
							: null}

						{this.state.dailyActivity.videoJumps !== undefined && this.state.dailyActivity.videoJumps.count !== 0 ?
							<tr>
								<td>VIDEO JUMPS </td>
								<td>{this.state.dailyActivity.videoJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.videoJumps.value)}</td>
							</tr>
							: null}

						{this.state.dailyActivity.withVideoJumps !== undefined && this.state.dailyActivity.withVideoJumps.count !== 0 ?
							<tr>
								<td>VIDEOS </td>
								<td>{this.state.dailyActivity.withVideoJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.withVideoJumps.value)}</td>
							</tr>
							: null}

						{this.state.dailyActivity.coachJumps !== undefined && this.state.dailyActivity.coachJumps.count !== 0 ?
							<tr>
								<td>COACH JUMPS </td>
								<td>{this.state.dailyActivity.coachJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.coachJumps.value)}</td>
							</tr>
							: null}
						{this.state.dailyActivity.coachedJumps !== undefined && this.state.dailyActivity.coachedJumps.count !== 0 ?
							<tr>
								<td>COACHED JUMPS </td>
								<td>{this.state.dailyActivity.coachedJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.coachedJumps.value)}</td>
							</tr>
							: null}


						{this.state.dailyActivity.wingsuitCoachJumps !== undefined && this.state.dailyActivity.wingsuitCoachJumps.count !== 0 ?
							<tr>
								<td>WINGSUIT COACH JUMPS </td>
								<td>{this.state.dailyActivity.wingsuitCoachJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.wingsuitCoachJumps.value)}</td>
							</tr>
							: null}
						{this.state.dailyActivity.wingsuitCoachedJumps !== undefined && this.state.dailyActivity.wingsuitCoachedJumps.count !== 0 ?
							<tr>
								<td>WINGSUIT COACHED JUMPS </td>
								<td>{this.state.dailyActivity.wingsuitCoachedJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.wingsuitCoachedJumps.value)}</td>
							</tr>
							: null}


						{this.state.dailyActivity.hopnpops !== undefined && this.state.dailyActivity.hopnpops.count !== 0 ?
							<tr>
								<td>HOP N POPS </td>
								<td>{this.state.dailyActivity.hopnpops.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.hopnpops.value)}</td>
							</tr>
							: null}

						{this.state.dailyActivity.solos !== undefined && this.state.dailyActivity.solos.count !== 0 ?
							<tr>
								<td>SOLO </td>
								<td>{this.state.dailyActivity.solos.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.solos.value)}</td>
							</tr>
							: null}

						{this.state.dailyActivity.gearRentals !== undefined && this.state.dailyActivity.gearRentals.count !== 0 ?
							<tr>
								<td>GEAR RENTALS </td>
								<td>{this.state.dailyActivity.gearRentals.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
								<td>{this.checkForNegatives(this.state.dailyActivity.gearRentals.value)}</td>
							</tr>
							: null}

						{countersales}
						{charges}

						<tr style={{ visibility: 'hidden' }}>
							<td>PREVIOUS BALANCE 	</td>
							<td></td>
							<td></td>
						</tr>

					</tbody>
				</table>

			</div>
		)

	}

	render() {
		// console.log("this.props.options this.props.options", this.props.options)

		const override = `
	        display: block;
	        margin: 0 auto;
	        border-color: red;
	      `;

		var currentBalanceString = this.state.dailyActivity.currentBalance >= 0 ? this.checkForNegatives(this.state.dailyActivity.currentBalance) : this.checkForNegatives(this.state.dailyActivity.currentBalance);
		var todayBalanceString = this.state.dailyActivity.todayBalance >= 0 ? this.checkForNegatives(this.state.dailyActivity.todayBalance) : this.checkForNegatives(this.state.dailyActivity.todayBalance);
		var totalBalanceString = this.state.dailyActivity.totalBalance >= 0 ? this.checkForNegatives(this.state.dailyActivity.totalBalance) : this.checkForNegatives(this.state.dailyActivity.totalBalance);
		var totalPaidString = this.state.dailyActivity.todayPaid >= 0 ? this.checkForNegatives(this.state.dailyActivity.todayPaid) : this.checkForNegatives(this.state.dailyActivity.todayPaid);

		if (this.props.mode !== "async") {
			console.log(this.props.options);
		}
		// console.log("this.propsthis.propsthis.props",this.props)

		return (
			<div>
				<Modal id="modal-report" aria-labelledby="example-custom-modal-styling-title"
					isOpen={this.state.isModalOpen} style={{ zIndex: '10503434', right: '28%' }}>
					<ModalHeader>View Details</ModalHeader>
					<ModalBody>
						<div className='complete-loading'>
							<ClipLoader
								css={override}
								sizeUnit={"px"}
								size={35}
								color={'#fff'}
								loading={this.state.isLoading}
							/>
						</div>
						<Row className="form-group">
							<Col md={12}>
								{this.renderSummary()}
							</Col>
						</Row>

						<div className="ViewAccounts-totalSection-246" style={{ paddingTop: 10, paddingBottom: 10 }}>

							<table className="StaffSummary" style={{ marginLeft: '6px', width: '97%' }}>
								<tbody>
									{/*	<tr>
									<td>PREVIOUS BALANCE </td>
									<td>{currentBalanceString !== "($ undefined)" ? currentBalanceString : "$0"}</td>
							</tr> */}
									<tr>
										<td>TODAYS BALANCE </td>
										<td> {todayBalanceString !== "($undefined)" ? todayBalanceString : "$0"}</td>
									</tr>
									<tr>
										<td>TOTAL PAID </td>
										<td>{totalPaidString !== "($undefined)" ? totalPaidString : "$0"}</td>
									</tr>
									{/* <tr>
									<td>TOTAL BALANCE </td>
									<td>{totalBalanceString !== "($undefined)" ? totalBalanceString : "$0"}</td>
								</tr> */}
								</tbody>
							</table>
						</div>

						<Row>
							<Col>
								{
									this.state.jumperId !== '' &&
									<ViewDetail jumperId={this.state.jumperId} />
								}
							</Col>
							<Col>
								{
									this.state.jumperId !== '' && !this.state.isTandemStudent &&
									<TransferCredit jumperId={this.state.jumperId} />
								}
							</Col>
							<Col>
								<ChargeJumper jumperId={this.state.jumperId} token={this.state.cardsOnFile} value={Number(this.state.dailyActivity.totalBalance).toFixed(2)} isTandemStudent={this.state.dailyActivity.isTandemStudent} />
							</Col>
							<Col>
								<AddItem jumperId={this.state.jumperId} isTandemStudent={this.state.dailyActivity.isTandemStudent} />
							</Col>


						</Row>

						<Row className="form-group m-t-2-rem">
							<Col md={{ size: 9 }}>
								<button onClick={(e) => { e.preventDefault(); this.closeModal(); }} className="btn btn-link">CANCEL</button>
							</Col>
						</Row>
					</ModalBody>
				</Modal>


				<div style={{ width: '170px', position: "absolute", zIndex: 10 }}>
					{
						this.props.mode === "async" ?
							<AsyncSelect
								loadOptions={(newValue) => this.promiseOptions(newValue, this.props.options)}
								onInputChange={(val) => this.handleInputChange(val)}
								onChange={(val) => this.handleSelect(val)}
								placeholder={this.props.placeholder}
								defaultOptions={this.props.options.slice(0, 10)}
								styles={customStyles}
							/>
							:
							<Select options={this.props.options}
								onChange={(val) => this.handleTandemSelect(val)}
								placeholder={this.props.placeholder}
								styles={customStyles}
							/>
					}
				</div>
			</div>
		);
	}
}


export default SearchJumper
